import { render } from "./SearchBottomBar.vue?vue&type=template&id=2965903c"
import script from "./SearchBottomBar.vue?vue&type=script&lang=js"
export * from "./SearchBottomBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__